// extracted by mini-css-extract-plugin
module.exports = {"link":"InlineOrgPicker_link__3zjNw","linkText":"InlineOrgPicker_linkText__i4YLU","pr15":"InlineOrgPicker_pr15__1Yof-"};